export default __webpack_public_path__ + "static/media/released-icon.f6f308c0.svg";